import type { CityConfig } from "../city-template/types";

export const gardnervilleConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Gardnerville",
  state: "Nevada",
  stateAbbr: "NV",
  slug: "gardnerville",
  route: "/cities/gardnerville",
  title: "Emergency Passport Gardnerville NV | Expedited Passport Renewal Carson Valley | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport renewal in Gardnerville, NV — as fast as 24 hours. Fast passport services for Gardnerville, Minden, Genoa, and the Carson Valley region. A+ BBB rated, registered State Dept. courier. No agency visit required.",
  h1: "Emergency & Expedited Passport Services in Gardnerville, NV",
  heroSubtitle: "Passport expired before your trip from the Carson Valley? Fast Passport Center helps Gardnerville, Minden, and Douglas County travelers get expedited passports in as little as 24 hours. No agency visit required — Nevada has no local passport agency.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Gardnerville%20Nevada%20scenic%20Carson%20Valley%20view%20with%20Sierra%20Nevada%20mountain%20range%20along%20western%20horizon%2C%20wide%20fertile%20valley%20with%20green%20ranchlands%20and%20agricultural%20fields%2C%20US%20Route%20395%20running%20through%20the%20valley%20floor%2C%20Carson%20Range%20dramatic%20mountain%20silhouettes%20with%20blue%20skies%2C%20rural%20Nevada%20ranching%20community%20atmosphere%2C%20peaceful%20high%20desert%20valley%20landscape%2C%20long%20shadows%20from%20afternoon%20sun%20across%20the%20valley%20floor%2C%20classic%20Nevada%20small%20town%20rural%20charm%2C%20no%20text%20or%20people%20visible&width=1800&height=700&seq=gardnerville-nv-hero-001&orientation=landscape",
  heroImageAlt: "Gardnerville Nevada Carson Valley with Sierra Nevada mountain range and ranchlands",
  geoPosition: "38.9405;-119.7496",
  geoPlacename: "Gardnerville, Nevada",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "San Francisco Passport Agency",
    address: "95 Hawthorne St, Suite 600, San Francisco, CA 94105",
    distance: "Located in San Francisco — approximately 210 miles from Gardnerville via US-395 and I-80",
  },
  nearbyCitiesZips: [
    { name: "Gardnerville", zips: "89410, 89460" },
    { name: "Minden", zips: "89423" },
    { name: "Genoa", zips: "89411" },
    { name: "Topaz Lake", zips: "89410" },
    { name: "Wellington", zips: "89444" },
    { name: "Smith Valley", zips: "89430" },
    { name: "Carson City", zips: "89701, 89703, 89705" },
    { name: "South Lake Tahoe (CA)", zips: "96150, 96151" },
    { name: "Stateline", zips: "89449" },
    { name: "Dayton", zips: "89403" },
    { name: "Reno", zips: "89501, 89502, 89503" },
    { name: "Markleeville (CA)", zips: "96120" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Gardnerville and Carson Valley departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any UPS in Gardnerville or Carson City" },
  ],
  internalLinks: [
    { name: "Emergency passport services in Carson City", route: "/cities/carson-city" },
    { name: "Fast passport renewal in Reno", route: "/cities/reno" },
    { name: "Expedited passport help in South Lake Tahoe", route: "/cities/reno" },
    { name: "Urgent passport services in Sacramento", route: "/cities/sacramento" },
    { name: "Same-day passport help in San Francisco", route: "/cities/san-francisco" },
    { name: "Passport courier services in Northern Nevada", route: "/states/nevada" },
  ],
  fpcOfficeAddress: "100 W Liberty St, Reno, NV 89501",
  fpcOfficeNote: "Fast Passport Center serves Gardnerville and the Carson Valley remotely via secure overnight courier. We do not have a walk-in office in Gardnerville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Carson Valley residents.",
  fpcOfficeDistance: "Serving all of Gardnerville, Minden, Genoa, and the Carson Valley region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Carson Valley including Gardnerville, Minden, and Genoa. This historic agricultural region — set against the dramatic backdrop of the Sierra Nevada's Carson Range — is home to a vibrant ranching community, retirees, and a growing number of remote professionals who travel internationally. We serve this close-knit community with fast, reliable passport processing.",
  nearbyCitiesIntro: "We serve all Carson Valley communities including Gardnerville, Minden, Genoa, Topaz Lake, Wellington, and the surrounding Douglas County areas. We also serve nearby Carson City, South Lake Tahoe, Stateline, and Dayton. Our overnight shipping labels work from any UPS location — mountain living doesn't slow us down.",
  howItWorksIntro: "Most Gardnerville travelers complete everything online and ship documents overnight. No need to drive over the mountains to Sacramento or San Francisco. Our emergency passport process delivers fast results for Carson Valley travelers.",
  mistakesIntro: "Carson Valley residents live in one of Nevada's most scenic regions — but that beauty means mountain driving to agencies. Here are the most common passport mistakes we see.",
  testimonialsIntro: "Gardnerville and Douglas County travelers trust us when their international departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Gardnerville? Here are the most common ones we hear from Carson Valley travelers.",
  statePageRoute: "/states/nevada",
  statePageName: "Nevada",
  dmvWebsite: "https://dmv.nv.gov",
  dmvLabel: "Nevada DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Nearest agency is San Francisco (210 miles)",
        "Sierra Nevada crossing required",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Gardnerville travelers with immediate departure needs — as fast as 24 hours for urgent flights from Reno-Tahoe International Airport.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Carson Valley adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance for Gardnerville and Douglas County residents.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance — helpful for travelers who lose documents in the Lake Tahoe and Carson Valley region.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Douglas County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Gardnerville Nevada travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Gardnerville NV and the Carson Valley." },
    { name: "New Passport", description: "First-time passport application assistance for Gardnerville and Douglas County residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rebecca T.",
      location: "Gardnerville, NV",
      rating: 5,
      text: "Planned a ski trip to Switzerland with friends in Tahoe. Realized my passport expired just 8 days before. Fast Passport Center renewed it in 2 days and I made my flight. They saved our ski trip!",
      service: "Passport Renewal",
    },
    {
      name: "Jim B.",
      location: "Minden, NV",
      rating: 5,
      text: "Rancher traveling to Australia for an agricultural exchange program. Needed a passport renewal in a hurry. They processed it in 48 hours and everything went perfectly. Great service for the Carson Valley.",
      service: "Emergency Passport",
    },
    {
      name: "Maria G.",
      location: "Gardnerville, NV",
      rating: 5,
      text: "My daughter needed her first passport for a school trip to Spain. We live in a rural part of the valley and were worried about timing. Fast Passport Center got it done in 5 days. Excellent communication the whole way.",
      service: "New Passport",
    },
    {
      name: "Dave R.",
      location: "Genoa, NV",
      rating: 5,
      text: "Lost my passport somewhere between Genoa and Lake Tahoe. Needed a replacement for a business trip to London. They got it done in 48 hours. Shocked at how smooth the process was from such a small town.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "gardnerville-1",
      name: "Gardnerville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1267 Us Highway 395 N",
      city: "Gardnerville",
      state: "NV",
      zip: "89410",
      phone: "(775) 782-2254",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Gardnerville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Gardnerville facility. Appointment recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "gardnerville-2",
      name: "Minden Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1640 Us Highway 395 N",
      city: "Minden",
      state: "NV",
      zip: "89423",
      phone: "(775) 782-2751",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2 miles north of Gardnerville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Minden and north Gardnerville. Appointments recommended. Convenient for both communities.",
      icon: "ri-mail-line",
    },
    {
      id: "gardnerville-3",
      name: "Carson City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1385 Musser St",
      city: "Carson City",
      state: "NV",
      zip: "89701",
      phone: "(775) 882-2155",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of Gardnerville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility in the Carson City-Carson Valley area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "gardnerville-4",
      name: "Douglas County Clerk — Minden",
      type: "County Clerk Passport Acceptance",
      address: "1616 8th St",
      city: "Minden",
      state: "NV",
      zip: "89423",
      phone: "(775) 782-9014",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "2 miles north of Gardnerville",
      website: "https://www.douglascountynv.gov/",
      websiteLabel: "Douglas County Clerk",
      notes: "Full-service county government. Passport acceptance with appointment. Best option for Douglas County residents.",
      icon: "ri-government-line",
    },
    {
      id: "gardnerville-5",
      name: "South Lake Tahoe Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1046 Al Tahoe Blvd",
      city: "South Lake Tahoe",
      state: "CA",
      zip: "96150",
      phone: "(530) 544-3853",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles west of Gardnerville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative facility across the state line. Convenient for Lake Tahoe area travelers. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "gardnerville-6",
      name: "Nevada DMV — Carson City",
      type: "State DMV Acceptance Facility",
      address: "555 Wright Way",
      city: "Carson City",
      state: "NV",
      zip: "89711",
      phone: "(775) 684-4368",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "15 miles from Gardnerville",
      website: "https://dmv.nv.gov/",
      websiteLabel: "Nevada DMV",
      notes: "State capital DMV with full services. REAL ID processing. Online appointment recommended.",
      icon: "ri-car-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 210 miles to San Francisco over Sierra", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Carson Valley photo options are limited. Ensure your photos are exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at small-town acceptance facilities like Gardnerville and Minden.",
    },
    {
      icon: "ri-cloud-windy-line",
      title: "Underestimating Sierra Mountain Travel",
      description: "The San Francisco Passport Agency is 210 miles away and requires crossing the Sierra Nevada. In winter, this can be dangerous or impassable. Our courier service eliminates mountain travel entirely.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, you'll be turned away at any regional passport agency — and that mountain drive was for nothing.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This is especially important for Carson Valley families using small Douglas County acceptance facilities.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Nevada has no local passport agency. Standard processing takes 8–11 weeks. Start expedited at least 3 weeks before travel, especially from rural Carson Valley locations.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Gardnerville, Minden, or Carson City." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Gardnerville address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Gardnerville, NV?",
      a: "Fast Passport Center offers emergency passport processing in Gardnerville in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities. Nevada has no local passport agency — the nearest is San Francisco, 210 miles via US-395 and I-80 over the Sierra Nevada — so our courier service is the fastest, most practical option for Carson Valley travelers.",
    },
    {
      q: "What is the nearest passport agency to Gardnerville?",
      a: "The nearest passport agency is the San Francisco Passport Agency, approximately 210 miles from Gardnerville. The route requires crossing the Sierra Nevada mountains. Fast Passport Center's courier service eliminates the need for any mountain travel and delivers 24–48 hour turnaround for Carson Valley residents.",
    },
    {
      q: "Does Gardnerville have passport acceptance facilities?",
      a: "Yes. The Gardnerville Post Office at 1267 US Highway 395 N offers passport acceptance by appointment. Additionally, the Minden Post Office is just 2 miles north, the Douglas County Clerk in Minden offers full passport services, and the larger Carson City Post Office is 15 miles north for the most comprehensive service.",
    },
    {
      q: "Do you serve Minden and Genoa as well as Gardnerville?",
      a: "Yes. Fast Passport Center serves all three communities across the Carson Valley — Gardnerville, Minden, and Genoa — plus surrounding areas like Topaz Lake, Wellington, and Smith Valley. Our overnight shipping labels work from any UPS location in the valley, so no matter which community you call home, we get your passport to you fast.",
    },
    {
      q: "Can I get a passport renewed from the Carson Valley without driving over the mountains?",
      a: "Absolutely. You never need to leave the Carson Valley. Fast Passport Center's entire process is done via overnight courier. Complete your application online, we send you a prepaid shipping label, and your new passport is delivered to your Gardnerville or Minden address within days — no mountain driving required.",
    },
    {
      q: "What if I need a passport for international travel and I'm in a rural part of Douglas County?",
      a: "Douglas County's rural character doesn't slow us down. Our overnight courier system works from any UPS location. Whether you're in the heart of Gardnerville, a ranch in the Carson Valley, or even near Topaz Lake, we can get your passport processed in 24–48 hours for emergencies.",
    },
    {
      q: "How much does expedited passport service cost in Gardnerville?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your departure date.",
    },
  ],
  photoLocations: [
    { name: "Gardnerville Post Office", address: "1267 US Highway 395 N, Gardnerville, NV 89410", hours: "Mon–Fri: 9AM–4PM (photo by appointment)", website: "https://tools.usps.com/find-location.htm" },
    { name: "Walgreens — Carson City", address: "1815 US-395, Carson City, NV 89701", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Carson City", address: "1421 E William St, Carson City, NV 89701", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Carson City", address: "1971 California St, Carson City, NV 89701", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–4PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Carson City", address: "3770 US-395, Carson City, NV 89705", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Reno", address: "1201 Terminal Way, Reno, NV 89502", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
    { name: "Costco — Reno", address: "333 Bill Ave, Reno, NV 89502", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/" },
    { name: "CVS Pharmacy — South Carson", address: "4340 S Carson St, Carson City, NV 89701", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    {
      name: "Nevada DMV — Carson City",
      address: "555 Wright Way, Carson City, NV 89711",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "State capital DMV. Closest full-service DMV to Gardnerville. REAL ID processing. Online appointment recommended.",
      featured: true,
    },
    {
      name: "Douglas County Clerk — Minden",
      address: "1616 8th St, Minden, NV 89423",
      hours: "Mon–Fri: 8AM–5PM",
      note: "County government services for Douglas County residents. Passport acceptance and vital records.",
      featured: true,
    },
    {
      name: "Nevada DMV — Reno",
      address: "555 Wright Way, Carson City, NV 89711",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Alternative full-service DMV. 50 miles from Gardnerville via US-395.",
      featured: false,
    },
    {
      name: "South Lake Tahoe DMV (CA)",
      address: "3368 Sandy Way, South Lake Tahoe, CA 96150",
      hours: "Mon–Fri: 8AM–5PM",
      note: "California DMV across the state line. For Gardnerville residents near Lake Tahoe. 30 miles from Gardnerville.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RNO",
      name: "Reno-Tahoe International Airport",
      distance: "50 miles from Gardnerville via US-395",
      address: "2001 E Plumb Ln, Reno, NV 89502",
      note: "The primary airport for the Carson Valley. Direct service to Mexico and connecting international flights. About 50 miles north via US-395.",
      flightUrl: "https://www.renoairport.com/",
      flightLabel: "Reno-Tahoe Airport",
      featured: true,
    },
    {
      code: "SFO",
      name: "San Francisco International Airport",
      distance: "210 miles from Gardnerville",
      address: "San Francisco, CA 94128",
      note: "Primary West Coast hub. Home to the San Francisco Passport Agency. Requires Sierra Nevada crossing.",
      flightUrl: "https://www.flysfo.com/",
      flightLabel: "SFO Airport",
      featured: false,
    },
    {
      code: "SMF",
      name: "Sacramento International Airport",
      distance: "140 miles from Gardnerville",
      address: "6900 Airport Blvd, Sacramento, CA 95837",
      note: "Alternative regional hub. Some Carson Valley travelers use this for international connections.",
      flightUrl: "https://www.sacramento.aero/smf/",
      flightLabel: "Sacramento Airport",
      featured: false,
    },
  ],
};